module.exports = __webpack_public_path__ + "static/media/3.66a0df03.png";